import { login } from '@/api'
import { base64 } from '../utils/index'
const actions = {
  // 获取资金管理类表
  // getFundsAuth({ commit, state }, homeGoFunds) {
  //   let listType = state.listType
  //   if (listType == 0) {
  //     if (homeGoFunds) {
  //       router.push({
  //         path: '/deposit'
  //       })
  //     }
  //   } else {
  //     let params = {
  //       pagePlatformType: 'PC'
  //     }
  //     login.getGoldPageList(params).then(res => {
  //       if (res.IsSuccess) {
  //         commit('setFundsAuth', res.Data)
  //         if (homeGoFunds) {
  //           let flag = 0
  //           for (const iterator of res.Data) {
  //             //&& !(iterator.isFirst=='0' && iterator.pageName=='网上支付')
  //             if (iterator.pageStatus == 0 && flag != 1 && ((iterator.isFirst == '1' && iterator.isFirstStatus == '0') || (iterator.isFirst == '0' && iterator.notFirstStatus == '0'))) {
  //               let label = iterator.pageName
  //               if (label === '充值码支付') {
  //                 label = '商城支付'
  //               }
  //               for (const leftItem of state.leftList[3].children) {
  //                 if (new RegExp(label).test(leftItem.meta.title)) {
  //                   flag = 1
  //                   router.push({
  //                     path: leftItem.path
  //                   })
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     })
  //   }

  // },
  // 登录切换判断拥有账户
  async switch ({ commit }) {
    let type = JSON.parse(base64.decode(localStorage.getItem('I'))).type == 1 ? 0 : 1
    let res = await login.switch({ type })
    if (res.IsSuccess) {
      if (type == '0') {
        commit('setAccountType', 2)
        commit('setListType', 1)
        // 真实账户切换到模拟后需要再次切换回去
        await login.switch({ type: 1 })
      } else if (type == '1') {
        commit('setAccountType', 2)
        commit('setListType', 1)
        // 如果是为模拟账户切换有真实账户  则设置role
        if (res.Data.jfAccount.role) {
          commit('setUserRole', res.Data.jfAccount.role)
        }
      }
    } else {
      if (type == '0') {
        commit('setAccountType', 1)
        commit('setListType', 1)
      } else if (type == '1') {
        commit('setAccountType', 0)
        commit('setListType', 0)
      }
    }
  },
  // 资金管理权限判断
  // fundsStatus({ state }, text) {
  //   for (let authItem of state.fundsAuth) {
  //     let label = authItem.pageName
  //     if (label === '充值码支付') {
  //       label = '商城支付'
  //     }
  //     if (new RegExp(label).test(text)) {
  //       let params = {
  //         id: authItem.id
  //       }
  //       login.checkGoldPageList(params).then(res => {
  //         if (res.IsSuccess) {
  //           if (res.Data.pageStatus === '1') {
  //             authF(state, '权限变动，请重新操作')
  //           }
  //         } else {
  //           authF(state, '获取权限错误，请重新登录')
  //         }
  //       }).catch(res => {
  //         authF(state, '获取权限错误，请重新登录')
  //       })
  //     }
  //   }
  // },
  // 新老支付判断
  // jfdepositPage({ state, commit }, params) {
  //   let res = funds.jfdepositPage()
  //   if (!!res && res.IsSuccess) { //1 老版本 2新版本
  //     commit('setIsNewDeposit', res.Data == '2')
  //   }
  // }
}

// function authF(state, text) {

//   if (state.userRole == 4 || state.userRole == 5 || /www.jf24k/.test(window.location.origin)) {
//     // let clientid = localStorage.getItem('clientid')
//     // localStorage.clear();
//     // localStorage.setItem('clientid', clientid);
//     // window.location.href = '/login'
//     router.push({
//       path: '/login',
//       replace: true
//     })
//     setTimeout(() => {
//       window.location.reload()
//     }, 2000)
//   } else {
//     VueCookie.delete('remember')
//     let clientid = localStorage.getItem('clientid')
//     localStorage.clear();
//     localStorage.setItem('clientid', clientid);
//     router.push({
//       path: '/login',
//       replace: true
//     })
//   }



//   Message.error({
//     message: text
//   });
// }
export default actions


// WEBPACK FOOTER //
// ./src/store/actions.js